import React from 'react'
import ManagerInfoCardView from './ManagerInfoCardView/ManagerInfoCardView'
import { useSingleTeam } from '../../../hooks'
import UserInfo from '../../../../user/components/UserInfo'

/**
 * Props for the ManagerInfoCardPresenter component.
 */


export interface ManagerInfoCardPresenterProps {
  TitleComponent?: React.FC
}
function ManagerInfoCardPresenter({TitleComponent}: ManagerInfoCardPresenterProps) {
  const {isLoading, singleTeamData} = useSingleTeam()

  if (isLoading || !singleTeamData) return <></>

  if (!singleTeamData.team_manager) return <></>

  return (

    <>
    {TitleComponent && <TitleComponent/>}
    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
    {singleTeamData?.team_manager.map((managerId) => (<>

      <ManagerInfoCardView 
    lastName={() => <UserInfo id={managerId} info="lastname"/> }
    firstName={() => <UserInfo id={managerId} info="username"/> }
    email={() => <UserInfo id={managerId} info="email"/> }
  
    />
    </>
    ))}
    </div>
    </>
  )

   
}

export default ManagerInfoCardPresenter